// extracted by mini-css-extract-plugin
module.exports = {"dropdownDesk":"HeaderDropdown_dropdownDesk__DG9Y9","dropdownMobile":"HeaderDropdown_dropdownMobile__GvAUF"};